import { allRequestsHaveCompleted } from "@ane/core/lib/models";
const getDraftWorkspaceDictionaryKey = ({
  workspaceId,
  metricSetName,
  draftName
}) => `${workspaceId}_${metricSetName}_${draftName}`;
const getDraftExperimentationGroupDictionaryKey = ({
  experimentationGroupId,
  metricSetName,
  draftName
}) => `${experimentationGroupId}_${metricSetName}_${draftName}`;
const hasWriteAccessSelector = ({ workspaceId, metricSetName, draftName }, state) => {
  var _a;
  return (_a = state.maui.global.user_metric_write_access[getDraftWorkspaceDictionaryKey({
    workspaceId,
    metricSetName,
    draftName
  })]) == null ? void 0 : _a.data;
};
const hasScorecardLayoutSelector = (state) => {
  var _a;
  return allRequestsHaveCompleted(state.maui.draft.scorecard_layouts.status) ? !!((_a = state.maui.draft.scorecard_layouts.data) == null ? void 0 : _a.length) : true;
};
export {
  getDraftExperimentationGroupDictionaryKey,
  getDraftWorkspaceDictionaryKey,
  hasScorecardLayoutSelector,
  hasWriteAccessSelector
};
//# sourceMappingURL=CheckUserAccess.selectors.js.map
